import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/svg/top-image.svg'
import _imports_1 from '@/assets/images/svg/circles-bg.svg'
import _imports_2 from '@/assets/images/svg/star.svg'
import _imports_3 from '@/assets/images/svg/logo-small.svg'


const _withScopeId = n => (_pushScopeId("data-v-4d55ba5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<section class=\"content-top content-container\" data-v-4d55ba5c><div class=\"content-top-texts\" data-v-4d55ba5c><div class=\"content-top-texts-circle\" data-v-4d55ba5c></div><h1 class=\"content-top-texts-title\" data-v-4d55ba5c> A digital marketing <br data-v-4d55ba5c> agency with an edge! </h1><p class=\"content-top-texts-title2\" data-v-4d55ba5c>Promote your brand through Social Media</p><div class=\"content-top-texts-subtitle\" data-v-4d55ba5c><div class=\"content-top-texts-subtitle-line\" data-v-4d55ba5c></div><p class=\"content-top-texts-subtitle-text\" data-v-4d55ba5c>Enjoy growth in sales and <br data-v-4d55ba5c> increased brand awareness</p></div></div><img class=\"content-top-image\" src=\"" + _imports_0 + "\" alt=\"top-image\" data-v-4d55ba5c></section>", 1)
const _hoisted_3 = {
  class: "content-steps",
  id: "about-us"
}
const _hoisted_4 = { class: "content-steps-row content-container" }
const _hoisted_5 = { class: "content-steps-row-item-step" }
const _hoisted_6 = { class: "content-steps-row-item-title" }
const _hoisted_7 = { class: "content-steps-row-item-description" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "content-steps-bg",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "content-container blockTitle" }, "Work with us", -1))
const _hoisted_10 = { class: "content-ads--row content-container" }
const _hoisted_11 = { class: "content-ads--row-item-title" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "content-ads--row-item-title-star",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_13 = { class: "content-ads--row-item-title-text" }
const _hoisted_14 = { class: "content-ads--row-item-options" }
const _hoisted_15 = { class: "content-ads--row-item-options-option" }
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<section class=\"content-footer\" id=\"contact\" data-v-4d55ba5c><div class=\"content-footer-flexes content-container\" data-v-4d55ba5c><div class=\"logoRow\" data-v-4d55ba5c><img class=\"content-footer-logo\" src=\"" + _imports_3 + "\" alt=\"logo-black\" data-v-4d55ba5c><p class=\"logoMain\" data-v-4d55ba5c>Digital Cards <span class=\"logoSecondary\" data-v-4d55ba5c>Solutions Limited</span></p></div><div class=\"content-footer-info\" data-v-4d55ba5c><div class=\"content-footer-info-item\" data-v-4d55ba5c><div class=\"content-footer-info-item-top\" data-v-4d55ba5c><p class=\"content-footer-info-item-top-title\" data-v-4d55ba5c>Address</p><div class=\"content-footer-info-item-top-line\" data-v-4d55ba5c></div></div><p class=\"content-footer-info-item-text\" data-v-4d55ba5c>Suite C, Level 7, World Trust Tower <br data-v-4d55ba5c> 50 Stanley Street, Central <br data-v-4d55ba5c> Hong Kong</p></div><div class=\"content-footer-info-item\" data-v-4d55ba5c><div class=\"content-footer-info-item-top\" data-v-4d55ba5c><p class=\"content-footer-info-item-top-title\" data-v-4d55ba5c>Work Inquiries</p><div class=\"content-footer-info-item-top-line second\" data-v-4d55ba5c></div></div><p class=\"content-footer-info-item-text\" data-v-4d55ba5c>support@dcsl.pro</p></div></div><p class=\"content-footer-license\" data-v-4d55ba5c>@ 2022 Digital Cards Solutions Limited</p></div></section>", 1)

import VueScrollTo from 'vue-scrollto'
import { inject, reactive } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Content',
  setup(__props) {

const scrollTo = VueScrollTo.scrollTo

const data = reactive({
  steps: [
    {
      step: '01',
      title: 'Leave a message',
      description: 'Leave us your contact details along with the website of your company and we will get back to you within 48 hours!'
    },
    {
      step: '02',
      title: 'Let\'s talk!',
      description: 'We will call or email you to talk about your business goals and priorities.'
    },
    {
      step: '03',
      title: 'Receive a proposal',
      description: 'Based on the discussions held we will reach out with a comprehensive proposal that addresses the needs your business has and a quote that meets your budget.'
    },
    {
      step: '04',
      title: 'Get ready for changes',
      description: 'Once the terms are agreed upon, we will start executing the strategy that will change your business once and for all.'
    }
  ],
  ads: [
    {
      title: 'Facebook Ad Management',
      options: [
        'Paid Media Strategy & Setup',
        'Audience Mapping',
        'Custom Ad Creative & Copywriting',
        'Live Reporting Dashboard'
      ]
    },
    {
      title: 'TikTok Ad Management',
      options: [
        'Creative Strategy Planning Session',
        'Custom Creative Plan',
        'Video Design Based On Your Project Needs',
        'Monthly Reports & Strategy  Calls'
      ]
    },
    {
      title: 'Google Ad Management',
      options: [
        'Keyword Research & Strategy',
        'Custom Creative Plan',
        'Custom Ad Creative & Copywriting',
        'Live Reporting Dashboard'
      ]
    }
  ]
})

return (_ctx: any,_cache: any) => {
  const _component_Achieve = _resolveComponent("Achieve")!
  const _component_Utilize = _resolveComponent("Utilize")!
  const _component_Contact = _resolveComponent("Contact")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.steps, (item, key) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "content-steps-row-item",
            key: `step-${key}`
          }, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(item.step), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(item.title), 1),
            _createElementVNode("p", _hoisted_7, _toDisplayString(item.description), 1)
          ]))
        }), 128))
      ]),
      _hoisted_8
    ]),
    _createVNode(_component_Achieve),
    _hoisted_9,
    _createElementVNode("section", _hoisted_10, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.ads, (item, key) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "content-ads--row-item",
          key: `ads-${key}`
        }, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("p", _hoisted_13, _toDisplayString(item.title), 1)
          ]),
          _createElementVNode("ul", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (option, option_key) => {
              return (_openBlock(), _createElementBlock("li", {
                key: `option-${option_key}`
              }, [
                _createElementVNode("p", _hoisted_15, _toDisplayString(option), 1)
              ]))
            }), 128))
          ])
        ]))
      }), 128))
    ]),
    _createVNode(_component_Utilize),
    _createVNode(_component_Contact),
    _hoisted_16
  ]))
}
}

})